import { render, staticRenderFns } from "./SimpleToggle.vue?vue&type=template&id=6f32d7e5&scoped=true"
import script from "./SimpleToggle.vue?vue&type=script&lang=js"
export * from "./SimpleToggle.vue?vue&type=script&lang=js"
import style0 from "./SimpleToggle.vue?vue&type=style&index=0&id=6f32d7e5&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32d7e5",
  null
  
)

export default component.exports